export default {
      id: "arcs_demarches-usage",
      viewBox: "0 0 215 220",
      url: "../dist/images/" + "sprite.svg#arcs_demarches-usage",
      toString: function () {
        return this.url;
      }
    }